import { appointmentStep, status } from "./appointment.mjs";

export const interestingAppointmentStatus = [
  status.WAITING,
  status.ASSIGNED,
  status.TREATING,
  status.TREATED,
];

export const appointmentStatusPriority = Object.fromEntries(
  interestingAppointmentStatus.entries().map(([k, v]) => [v, k]),
);

export const cleaningAppointmentSteps = [
  appointmentStep.CHAIR_CLEANING,
  appointmentStep.APPOINTMENT_FINISHED,
];
